/**
 * Redirige /home (y rutas legacy) a /store/:storeSlug (inicio del panel tipo Shopify).
 * Usa useEffect + useNavigate para evitar "Maximum update depth exceeded" (Navigate en render provoca bucle).
 */
import { useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@smarty/shared';
import { storePath } from '@/config/routes.config';
import { RedirectLoading } from '@/components/RedirectLoading';

export function RedirectToStore() {
  const navigate = useNavigate();
  const { storeSlug, loading, tenantId } = useAuth();
  const didRedirect = useRef(false);

  useEffect(() => {
    if (loading || !tenantId || !storeSlug) return;
    if (didRedirect.current) return;
    const target = storePath(storeSlug, '');
    didRedirect.current = true;
    navigate(target, { replace: true });
  }, [loading, tenantId, storeSlug, navigate]);

  if (loading || !tenantId || !storeSlug) return <RedirectLoading />;
  return <RedirectLoading />;
}
